import React from 'react';
import styled from 'styled-components';

const MilesOfferContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.unit(0.5)};
  &.miles-offer-extra-padding {
    padding: 10px 0;
  }
`;

const MilesDisplay = styled.span`
  ${({ theme, $size }) => theme.typographyRebrand.heading[$size]}
  color: ${({ theme }) => theme.c.text.primary};
`;

const MilesDisplayRegular = styled.span`
  ${({ theme, $size }) => theme.typographyRebrand.body[$size]}
  color: ${({ theme }) => theme.c.text.primary};
  text-decoration: line-through;
`;

const formatCurrency = (locale, amount) => {
  return locale === 'en' ? `$${amount}` : `${amount}$`;
};

const milesLabel = (amount, singular, plural) => {
  return (amount === 1 && singular) || plural;
};

/**
 * Returns the value of a multiplier
 * if it is a valid multiplier. In case it does not it returns 0.
 * @param {{value: number; startDate:string; endDate:string }} multiplier
 * @returns {number} Multiplier value or zero
 */
const multiplierValue = (multiplier) => {
  if (
    multiplier &&
    multiplier.value &&
    multiplier.startDate &&
    multiplier.endDate
  ) {
    return multiplier.value;
  }
  return 0;
};

const MilesOffer = (props) => {
  const {
    multiplier,
    siteWideMultiplier,
    baseMiles,
    amountPerBaseMiles,
    singularMilesText,
    singularFlatRateMilesText,
    pluralFlatRateMilesText,
    locale = 'en',
    size = 'md',
  } = props;

  // Isolate 'for' text for non-flat-rate offers until label can be added to CMS
  const forLabel = ` ${singularMilesText.split(/ /)[1] || 'for'}`;

  const retailerPromo = multiplierValue(multiplier);
  const siteWidePromo = multiplierValue(siteWideMultiplier);

  // Determine whether store has an active multiplier or site wide multiplier
  const validMultiplier = retailerPromo || siteWidePromo;

  // Offer Type is Flat Rate if no doller amount per miles is defined
  const flatRateOffer = !amountPerBaseMiles || amountPerBaseMiles === '';

  // Primary amount of miles to display
  const milesAmount =
    (validMultiplier && (retailerPromo + siteWidePromo) * baseMiles) ||
    baseMiles;

  // Text to display after miles amount
  const milesText = milesLabel(
    milesAmount,
    singularFlatRateMilesText,
    pluralFlatRateMilesText
  );
  const baseMilesText = milesLabel(
    baseMiles,
    singularFlatRateMilesText,
    pluralFlatRateMilesText
  );

  const localizedAmount = `${forLabel} ${formatCurrency(
    locale,
    amountPerBaseMiles
  )}`;

  // If multiplier, we calculate the multiplier x base, strike out base and show miles in RED
  return (
    <MilesOfferContainer $size={size}>
      {validMultiplier ? (
        <MilesDisplayRegular>{`${baseMiles} ${baseMilesText}`}</MilesDisplayRegular>
      ) : null}
      <div>
        <MilesDisplay $size={size}>
          {`${milesAmount} ${milesText}`}
          {!flatRateOffer && localizedAmount}
        </MilesDisplay>
      </div>
    </MilesOfferContainer>
  );
};

export default MilesOffer;
